/* -------------------------- Design imports start -------------------------- */
import { Button } from "@mui/material";
/* --------------------------- Design imports end --------------------------- */

/* ------------------------ Functional imports start ------------------------ */
import React, { useEffect } from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import consentConfig from './utils/cookieConsent/CookieConsentConfig';
import './utils/cookieConsent/theme.module.css'
/* ------------------------- Functional imports end ------------------------- */

/* -------------------------------------------------------------------------- */
/*                               Start Component                              */
/* -------------------------------------------------------------------------- */
export default function CookieConsentComponent() {
  /* ------------------------------ Effects start ----------------------------- */
  useEffect(() => {void (async () => await CookieConsent.run(consentConfig))}, [])
  /* ------------------------------- Effects end ------------------------------ */
  /* -------------------------------------------------------------------------- */
  /*                              Render Component                              */
  /* -------------------------------------------------------------------------- */
  return (
    <Button
      variant='text'
      color='secondary'
      sx={{
        textTransform: 'none',
        padding: 'unset',
        fontSize: 'inherit',
      }}
      onClick={CookieConsent.showPreferences}
    >
      Cookie Einstellungen
    </Button>
  )
}
